// 导入所有数据源
import recruitDetailData from '@/data/recruitedDetailData';
import techDetailData from '@/data/techDetailData'

const dynamicRoute = [
  { // 招聘岗位详情页
    path: '/join',
    component: () => import('@/views/join'),
    hidden: true,
    children: [
      {
        path: 'recruit/:id',
        component: () => import('@/views/join/components/DetailPage.vue'),
        name: 'recruitDetail',
        hidden: true,
        props: true,
        meta: {
          title: '职位详情',
          breadcrumb: true,
          dynamicTitle: true,             // 标记需要动态标题
          dataSource: recruitDetailData,   // 直接绑定数据源
          lookupKey: 'id',                // 数据查找字段（对应路由参数）
          titleField: 'postName'          // 标题字段名（修正拼写错误）
        }
      }
    ]
  },
  {
    // 核心技术详情页面
    path:'/coreTechnology/detail/:id',
    component: ()=> import('@/views/core-technology/TechDetailPage.vue'),
    name: 'techDetail',
    hidden: true,
    props: true,
    meta: {
      title: '核心技术详情',
      breadcrumb: true,
      dynamicTitle: true,
      dataSource: techDetailData,
      lookupKey: 'id',
      titleField: 'title'
    }
  }
]
export default dynamicRoute
